import React from "react";
import { InputNumber } from "antd";

type VatCellProps = {
  cellData: any;
  rowId: number;
  schoolId: number | null;
  onSave: (schoolId: number, rowId: number, value: number) => void;
};

export const VatCell: React.FC<VatCellProps> = ({
  cellData,
  rowId,
  schoolId,
  onSave,
}) => {
  return (
    <InputNumber
      value={cellData}
      min={0}
      max={300}
      step={1}
      precision={0}
      onChange={(value) => {
        if (schoolId == null || value == null) return;

        const num = Number(value);
        if (Number.isNaN(num)) return;

        onSave(schoolId, rowId, num);
      }}
    />
  );
};
